import * as E from "../../either";
import * as M from "../../maybe";
import { fromValidate, validate } from "../validated";
export const optional = (t) => fromValidate((x) => {
    const r = validate(t, x);
    return E.of(E.is.Right(r) ? M.of(E.prRight(r)) : M.empty());
});
export const optionalE = (t) => fromValidate((x) => E.of(validate(t, x)));

